<template>
    <v-container fluid>
        <v-row>
            <v-col cols=12 class="display-3 font-weight-medium">
                <v-toolbar color="orange darken-2" dark>
                    <v-toolbar-title>{{ car.name }}</v-toolbar-title>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row justify="center" v-if="car.mpg.length < 1">
            <v-col cols=12 sm=4 class="display-2">
                <v-card>
                    <v-card-title>
                        Sorry! No data to show here!
                        <v-spacer></v-spacer>
                        <v-icon x-large>far fa-frown</v-icon>
                    </v-card-title>
                    <v-card-text>
                        Try adding some entries back on the dasboard! <v-icon>far fa-smile</v-icon>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!-- Average MPG -->
        <v-row justify="center" v-if="car.mpg.length > 0">
            <v-col cols=12 md=5 class="text-center">
                <v-progress-circular indeterminate size="64" width="10" v-if="loading"></v-progress-circular>
                <v-card v-if="!loading">
                    <v-container fluid>
                        <v-row justify="center">
                            <v-col class="headline font-weight-medium text-center" cols=12>
                                Average MPG
                            </v-col>
                            <v-col class="text-center" cols=12 md=1>
                                <v-icon x-large>fas fa-tachometer-alt fa-3x</v-icon>
                            </v-col>
                            <v-col class="headline" cols=12 md=3>{{ avg }}</v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
            <!-- Most Frequented Gas Station -->
            <v-col cols=12 md=5 class="text-center">
                <v-card v-if="!loading" :to="{name: 'Gas Stations', params: {carId: car._id}}">
                    <v-container fluid>
                        <v-row justify="center">
                            <v-col class="headline font-weight-medium text-center" cols=12>
                                Most Visited Gas Station
                            </v-col>
                            <v-col class="text-center" cols=12 md=1>
                                <v-icon x-large>fas fa-store-alt</v-icon>
                            </v-col>
                            <v-col class="headline" cols=12 md=3>{{ mostVisitedGasStation }}</v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
            <!-- Average fill up cost -->
            <v-col cols=12 md=5 class="text-center">
                <v-card v-if="!loading">
                    <v-container fluid>
                        <v-row justify="center">
                            <v-col class="headline font-weight-medium text-center" cols=12>
                                Average Fill Up Cost
                            </v-col>
                            <v-col class="text-center" cols=12 md=1>
                                <v-icon x-large>fas fa-dollar-sign</v-icon>
                            </v-col>
                            <v-col class="headline" cols=12 md=3>${{ avgFillUp }}</v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
            <!-- Most used gas -->
            <v-col cols=12 md=5 class="text-center">
                <v-card v-if="!loading">
                    <v-container fluid>
                        <v-row justify="center">
                            <v-col class="headline font-weight-medium text-center" cols=12>
                                Most Used Gas
                            </v-col>
                            <v-col class="text-center" cols=12 md=1>
                                <v-icon x-large>fas fa-clipboard</v-icon>
                            </v-col>
                            <v-col class="headline" cols=12 md=3>{{ mostUsedGas }}</v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
        <!-- MPG Entries -->
        <v-row>
            <v-col cols=12>
                <v-card class="display-1 font-weight-bold text-center pa-5 green darken-2 white--text">
                    MPG Entries
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="space-around" v-if="car.mpg.length > 0">
            <v-col class="text-center" v-for="entry in car.mpg" :key="entry._id" cols=12 md=3>
                <v-card>
                    <v-card-title>
                        <v-icon>fas fa-gas-pump</v-icon>
                        <v-spacer></v-spacer>
                        Details
                        <v-spacer></v-spacer>
                        <v-icon class="">fas fa-gas-pump</v-icon>
                    </v-card-title>
                    <v-container>
                        <v-row>
                            <v-col md>{{ formattedDate(entry.date) }}</v-col>
                            <v-col md>${{ entry.price }}</v-col>
                        </v-row>
                        <v-row>
                            <v-col cols=12 sm=6>Miles: {{ entry.miles }}</v-col>
                            <v-col cols=12 sm=6>Gals: {{ entry.gallons }}</v-col>
                            <v-col cols=12 sm=6>Gas Type: {{ entry.gasType }}</v-col>
                            <v-col cols=12 sm=6>MPG: {{ entry.mpg }}</v-col>
                        </v-row>
                        <v-row>
                            <v-col cols=12><v-divider></v-divider></v-col>
                        </v-row>
                        <v-row>
                            <v-col cols=12>
                                Gas Station
                            </v-col>
                            <v-col cols=12 sm=6>{{ entry.gasStation.name }}</v-col>
                            <v-col cols=12 sm=6>Address: {{ entry.gasStation.vicinity }}</v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import rp from "request-promise-native"

export default {
    // Prevent the user from accessing the dashboard if they are not logged in.
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.$store.state.token.length < 1) {            
                next("/login");
            } else {
                next();
            }
        })
    },
    props: ["carId"],
    data() {
        return {
            loading: true,
            avg: 0,

        }
    },
    computed: {
        car() {           
            return this.$store.getters.getSpecificCar(this.carId);
        },
        mostVisitedGasStation() {
            let map = {};
            let mostVisited = "";
            let names = [];

            // Get all of the gas station names
            this.car.mpg.forEach(item => {
                if (names.includes(item.gasStation.name) == false) {
                    names.push(item.gasStation.name);
                }
            });

            // Get the frequency of each gas station
            for (let i = 0; i < names.length; i++) {
                map[names[i]] = this.car.mpg.filter(item => item.gasStation.name === names[i]).length;
            }

            // Set temp to the first value of map by using the first element in the names array.
            let temp = map[names[0]];
            // Set most visited to the first name in the names arrayl;
            mostVisited = names[0];
            // Loop through the object to determine the mostVisited
            for (let n in map) {
                if (map[n] > temp) {
                    console.log(n);
                    // Update the highest number
                    temp = map[n];
                    // Set mostVisited.
                    mostVisited = n;
                }
            }              

            return mostVisited;
        },
        avgFillUp() {
            // Get the amount of fillups.
            let numFills = this.car.mpg.length;
            let avg = 0;

            // Calculate sum
            this.car.mpg.forEach(item => {
                avg += item.price;
            });

            // Return average
            return (avg/numFills).toFixed(2);

        },
        mostUsedGas() {
            let map = {};
            let mostUsed = "";
            let types = ["Regular", "Extra", "Super/Premium"];

            // Get the amount of each type of gas that appears.
            types.forEach(t => {
                map[t] = this.car.mpg.filter(item => item.gasType === t).length;
            })

            // Set temp to the first value of map by using the first element in the names array.
            let temp = map[types[0]];
            // Set most visited to the first name in the names arrayl;
            mostUsed = types[0];
            // Loop through the object to determine the mostVisited
            for (let n in map) {
                if (map[n] > temp) {
                    console.log(n);
                    // Update the highest number
                    temp = map[n];
                    // Set mostVisited.
                    mostUsed = n;
                }
            }          

            return mostUsed;
        }
    },
    methods: {
        formattedDate(d) {
            let newD = new Date(d);
            return newD.toLocaleDateString();
        }
    },
    mounted: async function () {      
        let self = this;

        // Options for request-promise-native
        let options = {
            method: "GET",
            uri: `${process.env.VUE_APP_HOST}/cars/${this.carId}/avgMpg`,
            auth: {
                bearer: self.$store.state.token
            },
            json: true
        };
        
        let res = await rp(options); 
        self.avg = (res.avg).toFixed(2);
        self.loading = false;
    }
    
}
</script>